import { render, staticRenderFns } from "./RecepcionTabs.vue?vue&type=template&id=514da824&"
import script from "./RecepcionTabs.vue?vue&type=script&lang=js&"
export * from "./RecepcionTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports